import { render, staticRenderFns } from "./EditTodo.vue?vue&type=template&id=2bebab41&scoped=true&"
import script from "./EditTodo.vue?vue&type=script&lang=js&"
export * from "./EditTodo.vue?vue&type=script&lang=js&"
import style0 from "./EditTodo.vue?vue&type=style&index=0&id=2bebab41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bebab41",
  null
  
)

export default component.exports